import { render } from "./CardSwiper.vue?vue&type=template&id=1b37adeb&scoped=true"
import script from "./CardSwiper.vue?vue&type=script&lang=js"
export * from "./CardSwiper.vue?vue&type=script&lang=js"

import "./CardSwiper.vue?vue&type=style&index=0&id=1b37adeb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b37adeb"]])

export default __exports__